import React, { useState } from 'react';
// import { LuArrowUpRight } from 'react-icons/lu';
import { Tooltip } from 'antd';
import parser from 'html-react-parser';
import { LuArrowUpRight } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';
import useIntervalTransition from '../../../../../../hooks/useIntervalTransition';
import HSButton from '../../../../../common/Button';
import { dealStatus } from '../../../../../login/utils/Status';
import { commaSeperator } from '../../../../../utils/validation';
import { Deals } from '../../../../deals/redux/types';
import { createInterestRate, createMinInvestment, getType } from '../../../utils';

const header: { title: string; className: string }[] = [
    {
        title: 'Deal',
        className: 'w-[28%]',
    },
    {
        title: 'Industry',
        className: 'w-[14%]',
    },
    {
        title: 'Instrument Type',
        className: 'w-[12%]',
    },
    {
        title: 'Target Funding Size',
        className: 'w-[14%]',
    },
    {
        title: 'Target Returns',
        className: 'w-[10%]',
    },
    {
        title: 'Tenor',
        className: 'w-[10%]',
    },
    {
        title: 'Min Investment',
        className: 'w-[12%]',
    },
    {
        title: 'Actions',
        className: 'w-[2%]',
    },
];

type Props = {
    list: Deals[];
    isRecentList?: boolean;
};
const DealsListDesktopView: React.FC<Props> = ({ list, isRecentList }) => {
    const navigate = useNavigate();
    const [visibleItems, setVisibleItems] = useState<number>(6);
    const currentIndex = useIntervalTransition(list.length, 300);
    let classHeading = 'font-[WorkSans-Semibold] text-xs text-[#13223E]';

    const colorObj = {
        title: 'text-[#13223E]',
        desc: 'text-[#142C53]',
        heading: 'bg-[#e2f8ec]',
        body: 'bg-[#F1F7FF]',
        headingText: 'text-[#000000]',
    };
    if (isRecentList) {
        colorObj.title = 'text-white';
        colorObj.desc = 'text-white';
        colorObj.heading = 'bg-[#27AE60]';
        colorObj.body = 'bg-[#545760]';
        colorObj.headingText = 'text-white';
        classHeading = 'font-[WorkSans-Semibold] text-xs text-white';
    }
    const handleLoadMore = () => {
        setVisibleItems((prev) => Math.min(prev + list.length, list.length));
    };

    return (
        <div className="w-full mb-6">
            <table className="border-separate" style={{ borderSpacing: '4px' }}>
                <thead>
                    <tr className={colorObj.heading}>
                        {header.map((item) => {
                            return (
                                <th
                                    align="left"
                                    className={`${item.className} font-[WorkSans-Semibold] px-3 py-2 text-[10px] ${colorObj.headingText}`}
                                >
                                    {item.title}
                                </th>
                            );
                        })}
                    </tr>
                </thead>
                <tbody>
                    {list.slice(0, visibleItems).map((item, index) => {
                        const { issuer, deal } = item || {};
                        const { image, info, status, uuid } = deal || {};
                        const { category } = issuer || {};
                        const { dealType, title, description, targetFundingSize, instrumentType, terms } =
                            info.summary || {};
                        const { currency, amountUpto2dp } = targetFundingSize || {};
                        const isStatus = status === dealStatus.upcoming || status === dealStatus.completed;

                        return (
                            <tr
                                key={`${uuid}_${index}_list_d_deals`}
                                className={colorObj.body}
                                style={{
                                    opacity: index < currentIndex ? 1 : 0,
                                    transform: `scale(${index < currentIndex ? 1 : 0.8})`,
                                    transition: 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out',
                                }}
                            >
                                <td className="w-[28%]">
                                    <div className="flex gap-1">
                                        <div
                                            className="bg-cover bg-no-repeat w-[55px]"
                                            style={image ? { backgroundImage: `url(${image})` } : {}}
                                        ></div>
                                        <div className="w-[calc(100%-66px)] py-2 px-3">
                                            <div className="flex gap-2 items-center mb-1">
                                                {getType(dealType) !== '' && (
                                                    <label className="bg-white w-auto px-2 py-1 text-[#142C53] font-[WorkSans-SemiBold] text-xs">
                                                        {getType(dealType)}
                                                    </label>
                                                )}
                                                <span
                                                    title={title}
                                                    className={`${colorObj.title} font-[WorkSans-Semibold] text-sm deals_title_ellipse w-40`}
                                                >
                                                    {title}
                                                </span>
                                            </div>
                                            <Tooltip title={description}>
                                                <span
                                                    className={`${colorObj.desc} text-xs cursor-pointer font-[WorkSans] line_truc_deals min-h-[32px]`}
                                                >
                                                    {description}
                                                </span>
                                            </Tooltip>
                                        </div>
                                    </div>
                                </td>
                                <td className={'w-[14%] px-3 py-2'} align="left" valign="top">
                                    <span className={classHeading}>{category}</span>
                                </td>
                                <td className={'w-[12%] px-3 py-2'} align="left" valign="top">
                                    {' '}
                                    <span className={classHeading}>{instrumentType}</span>
                                </td>
                                <td className={'w-[12%] px-3 py-2'} align="left" valign="top">
                                    {' '}
                                    <span className={classHeading}>
                                        {currency ? `${currency} ${commaSeperator(String(amountUpto2dp || 0))}` : 'NA'}
                                    </span>
                                </td>
                                <td className={'w-[12%] px-3 py-2'} align="left" valign="top">
                                    {' '}
                                    <span className={classHeading}>{parser(createInterestRate(deal))}</span>
                                </td>
                                <td className={'w-[10%] px-3 py-2'} align="left" valign="top">
                                    {' '}
                                    <span className={classHeading}>
                                        {terms?.tenorInMonths ? `${terms?.tenorInMonths} months` : 'NA'}
                                    </span>
                                </td>
                                <td className={'w-[12%] px-3 py-2'} align="left" valign="top">
                                    {' '}
                                    <span className={classHeading}>{parser(createMinInvestment(deal))}</span>
                                </td>
                                <td className="w-[2%] px-3 py-2" align="center" valign="middle">
                                    {status !== dealStatus.upcoming ? (
                                        <LuArrowUpRight
                                            onClick={() => !isStatus && navigate(`/deal/${uuid}`)}
                                            className="cursor-pointer"
                                            size={'1.5rem'}
                                            color="#41D17E"
                                        />
                                    ) : (
                                        '-'
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>

            <div className="flex justify-center mt-4 gap-2">
                {visibleItems < list.length && (
                    <HSButton
                        type="link"
                        title="See More"
                        onClick={() => {
                            handleLoadMore();
                        }}
                        disabled={visibleItems >= list.length}
                    />
                )}
            </div>
        </div>
    );
};

export default DealsListDesktopView;
